<!--
This is a small (badge) version of CO2 Emissions.
More detailed, full version (with code for each flight leg) can be found in "./_Deprecated/components/FlightCarbonEmissions"
-->

<template>
  <div>
    <article class="media">
      <figure class="">
        <img src="/images/co2_icon_185.png" alt="Placeholder image" style="height: 60px; opacity: 50%;">
      </figure>
      <div class="media-content">
        <div class="content">
          <p v-if="loading" style="line-height: 60px;"><b-skeleton :animated="animated" width="80%"></b-skeleton></p>
          <b-message v-else-if="error" type="is-danger" aria-close-label="Close message">
            <div class="is-size-7">
              There was an error loading Carbon Emissions data.
            </div>
          </b-message>
          <template v-else>
            <div v-if="extractedValues.length === 0">
              <b-message  type="is-warning" aria-close-label="Close message">
                <div class="is-size-7">
                  No Carbon Emission (CO<sub>2</sub>) data is available for this flight.
                </div>
              </b-message>
            </div>
            <p v-else class="is-size-6" style="line-height: 60px;"><strong>{{ co2Values }} CO<sub>2</sub></strong></p>
          </template>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
  name: "FlightCarbonEmissionsBadge",
  props: {
    journeys: Array,
  },
  data: function () {
    return {
      loading: true,
      error: false,
      animated: true,
      extractedValues: [],
    };
  },
  methods:{
    getCO2ValuesPerFlight(flightNumber, airlineCode, departureAirport, arrivalAirport, departureDate){
      //validate props first
      this.$helpers.validateProp(flightNumber);
      this.$helpers.validateProp(airlineCode);
      this.$helpers.validateProp(departureAirport);
      this.$helpers.validateProp(arrivalAirport);
      this.$helpers.validateProp(departureDate);

      let body = {
        "departureAirport": departureAirport,
        "arrivalAirport": arrivalAirport,
        "airlineCode":  airlineCode,
        "flightNumber": flightNumber,
        "departureDate": departureDate,
      }

      if(this.co2Info.flightsWithCO2Info.length > 0){
        const found = this.co2Info.flightsWithCO2Info.find(element => element.flightNumber === body.flightNumber);
        if(found){
          this.extractedValues.push(found.extractedMessage);
          this.loading = false;
        }
        else{
          this.callAPI('amadeus/air/flight-info', body);
        }
      }
      else{
        this.callAPI('amadeus/air/flight-info', body);
      }
    },
    processJourneys(journeys){
      for(const journey of journeys){
        for( const leg of journey.legs){
          this.getCO2ValuesPerFlight(leg.flightNumber, leg.marketingAirline.code, leg.departingAirport, leg.arrivingAirport, leg.departingAt.date);
        }
      }
    },
    callAPI(url, body){
      this.$app.huddleLabsServerCall('amadeus/air/flight-info', body)
          .then(result => {
                //// console.log('result of $app.huddleLabsServerCall:', result.messages);
                if (!result.error) {
                  // no error - continue
                  // parse messages array
                  let messages = result.messages;
                  if (Object.prototype.toString.call(messages) === '[object Array]') {

                    // this will get the CO2 string we're looking for
                    messages = messages[messages.length - 2];

                    //parse msg to get values (ECO and in KG)
                    const startStr = "CO2/PAX*";
                    const endStr = "ECO";
                    let extractedMessage = messages.substring(messages.indexOf(startStr), messages.indexOf(endStr));

                    //remove specific strings
                    extractedMessage = extractedMessage.replace(startStr, '');
                    extractedMessage = extractedMessage.replace("KG", '');

                    //extractedMessage = (extractedMessage[0] == ' ') ? extractedMessage.substr(1) : extractedMessage;
                    extractedMessage = extractedMessage.replace(/\s/g, '');

                    let extractedMessageFormatted = Number(Math.round(extractedMessage));

                    this.extractedValues.push(extractedMessageFormatted);
                    this.loading = false;

                    let newCO2Info = {
                      'flightNumber': body.flightNumber,
                      'extractedMessage': extractedMessageFormatted,
                    }
                    this.$store.dispatch('co2Info/addCO2ToFlightsInfo', newCO2Info);
                  }
                }
              }
          );
    },
  },
  computed: {
    ...mapState(['co2Info']),
    co2Values(){
      let co2KG = 0;
      let co2LBS = 0;
      for(const num of this.extractedValues) {
        co2KG += num;
      }

      return `${co2KG} kg`;
    }
  },
  mounted() {
    this.processJourneys(this.journeys);
  }
}
</script>

<style scoped>

</style>